import React from 'react';
import { HiOutlineChevronDown, HiOutlineCheck, HiOutlineXMark } from 'react-icons/hi2';

const COMPARISON_ROWS = [
  { feature: 'Monthly credits', light: '3,000', starter: '15,000', pro: '75,000', max: '200,000' },
  { feature: 'Cloud Browsers', light: '1', starter: '2', pro: '3', max: '5' },
  { feature: 'Scheduled tasks', light: '10', starter: '10', pro: '50', max: '100' },
  { feature: 'Team seats', light: '1 (solo)', starter: '1 (solo)', pro: '3', max: '5' },
  { feature: 'Browser Extension PRO', light: true, starter: true, pro: true, max: true },
  { feature: 'Credit top-ups', light: true, starter: true, pro: true, max: true },
  { feature: 'Page Unblocker', light: true, starter: true, pro: true, max: true },
  { feature: 'Data Labeling', light: true, starter: true, pro: true, max: true },
  { feature: 'Proxies', light: true, starter: true, pro: true, max: true },
  { feature: 'Integrations', light: true, starter: true, pro: true, max: true },
];

const CellValue = ({ value, isProColumn }) => {
  if (value === true) {
    return <HiOutlineCheck className={`w-4 h-4 mx-auto ${isProColumn ? 'text-cyan-500 dark:text-cyan-400' : 'text-emerald-500'}`} />;
  }
  if (value === false) {
    return <HiOutlineXMark className="w-4 h-4 mx-auto text-gray-300 dark:text-gray-700" />;
  }
  return (
    <span className={`text-sm font-medium ${isProColumn ? 'text-gray-800 dark:text-white font-semibold' : 'text-gray-600 dark:text-gray-300'}`}>
      {value}
    </span>
  );
};

const FeatureComparisonTable = ({ showComparison, setShowComparison }) => (
  <div className="text-center pt-2">
    <button
      onClick={() => setShowComparison(!showComparison)}
      className="inline-flex items-center gap-3 px-7 py-3.5 rounded-xl text-sm font-semibold bg-gray-50 dark:bg-gray-800/40 border border-gray-200 dark:border-gray-700/30 hover:border-cyan-400/40 dark:hover:border-cyan-400/30 hover:bg-gradient-to-r hover:from-cyan-500/5 hover:to-blue-500/5 text-gray-700 dark:text-gray-300 hover:text-cyan-600 dark:hover:text-cyan-400 transition-all duration-300 group shadow-sm hover:shadow-md"
    >
      <span>{showComparison ? 'Hide detailed comparison' : 'Compare all features side-by-side'}</span>
      <HiOutlineChevronDown className={`w-5 h-5 transition-transform duration-300 ${
        showComparison ? 'rotate-180' : ''
      }`} />
    </button>

    <div className={`overflow-hidden transition-all duration-500 ${
      showComparison ? 'max-h-[800px] opacity-100 mt-8' : 'max-h-0 opacity-0'
    }`}>
      <div className="rounded-xl border border-gray-200 dark:border-gray-700/30 bg-gradient-to-br from-gray-50 dark:from-gray-900/60 to-gray-100 dark:to-gray-800/40 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 dark:border-gray-800/50">
              <th className="text-left px-4 py-3.5 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider w-[30%]">Feature</th>
              <th className="px-4 py-3.5 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Light</th>
              <th className="px-4 py-3.5 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Starter</th>
              <th className="px-4 py-4 text-xs font-bold uppercase tracking-wider bg-gradient-to-b from-cyan-500/10 to-blue-500/5 border-x-2 border-cyan-400/30 dark:border-cyan-400/20">
                <span className="bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 bg-clip-text text-transparent">
                  Pro
                </span>
              </th>
              <th className="px-4 py-3.5 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Max</th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row, index) => (
              <tr key={index} className={`border-b border-gray-50 dark:border-gray-800/30 ${
                index % 2 === 0 ? 'bg-gray-50/50 dark:bg-gray-800/10' : ''
              }`}>
                <td className="text-left px-4 py-3.5 text-sm text-gray-600 dark:text-gray-300 font-medium">{row.feature}</td>
                <td className="px-4 py-3.5 text-center"><CellValue value={row.light} /></td>
                <td className="px-4 py-3.5 text-center"><CellValue value={row.starter} /></td>
                <td className="px-4 py-3.5 text-center bg-cyan-500/[0.06] dark:bg-cyan-500/[0.04] border-x-2 border-cyan-400/20 dark:border-cyan-400/10">
                  <CellValue value={row.pro} isProColumn />
                </td>
                <td className="px-4 py-3.5 text-center"><CellValue value={row.max} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default FeatureComparisonTable;
